import React, { useEffect, useState } from "react";
import "./style.css";
import SatisfactionChooser from "./SatisfactionChooser.js";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import SimpleMessage from "./SimpleMessage.js";
import Textarea from "./Textarea.js";
export default function SurveyWindow(props) {
    const { survey: { surveyContent }, } = props;
    const [step, setStep] = useState(0);
    const [results, setResults] = useState([]);
    useEffect(() => {
        setResults(new Array(surveyContent.length).fill(undefined));
    }, [surveyContent]);
    const current = surveyContent[step];
    return (React.createElement("div", { className: "survey-window-container" },
        React.createElement("div", { className: "survey-window-nav" },
            React.createElement("div", null,
                "Krok ",
                step + 1,
                " z ",
                surveyContent.length),
            props.hideExitButtons === true ?
                React.createElement(React.Fragment, null)
                : React.createElement("button", { onClick: () => props.onExit() }, "X")),
        current.type === "satisfaction-chooser" ?
            React.createElement(SatisfactionChooser, { result: results[step], content: current, onUpdate: (result) => setResults((old) => old.map((r, i) => (i !== step ? r : result))) })
            : current.type === "simple-message" ?
                React.createElement(SimpleMessage, { content: current, onUpdate: (result) => setResults((old) => old.map((r, i) => (i !== step ? r : result))) })
                : current.type === "textarea" ?
                    React.createElement(Textarea, { content: current, result: results[step], onUpdate: (result) => setResults((old) => old.map((r, i) => (i !== step ? r : result))) })
                    : React.createElement(React.Fragment, null),
        React.createElement("div", { className: "survey-window-menu" },
            props.hideExitButtons && step === 0 ?
                React.createElement(React.Fragment, null)
                : React.createElement(Button, { version: "filled-tonal", onClick: () => {
                        if (step > 0) {
                            return setStep(step - 1);
                        }
                        props.onExit();
                    } }, step > 0 ? "Cofnij" : "Zamknij"),
            React.createElement(Button, { onClick: () => {
                    if (results[step] === undefined)
                        return;
                    if (step + 1 === surveyContent.length) {
                        return props.onExit(results.map((result, index) => ({
                            ...result,
                            id: surveyContent[index].id,
                        })));
                    }
                    setStep(step + 1);
                }, isActive: results[step] !== undefined, classNames: "go-next-survey-window-button" }, step + 1 === surveyContent.length ? "Prześlij" : "Dalej"))));
}
